import { css } from "@emotion/react";

/**
 * Padding as a percentage is in reference to the width of the element. Learn this one simple trick to match the height of an element to the width. Browser manufacturers hate him.
 * @param borderSize If there is a border on the element, this must be subtracted from the width, since padding as a percentage includes the border width on two sides.
 * @returns A mixin
 */
export const matchHeightToWidth = (borderSize?: string) => css`
    padding-top: ${borderSize ? `calc(100% - (${borderSize} * 2))` : "100%"};
`;
